
import React, { ReactNode } from "react"
import { observer } from "mobx-react-lite";

import { useDispatchPage } from '../../helpers';
import DispatchModal from "./JobDispatchModal";
import { useStore } from "@vromo/mobx-react/mobx-react";
import { RootStore } from "@vromo/dashboard/src/stores/RootStore";

/** Place holder for modals that be rendered from different buttons */
export const ModalPlaceholder = observer<{ children?: ReactNode }>(({ children }) => {

    const { jobStore: { jobs } } = useStore<RootStore>('rootStore');
    const { jobSelection, updateJobSelection, areJobsSelected } = useDispatchPage()

    return (
        <>
            {
                areJobsSelected("dispatch") &&
                <DispatchModal
                    close={() => updateJobSelection("dispatch", "clear")}
                    isOpen={areJobsSelected("dispatch")}
                    jobs={Array.from(jobSelection("dispatch")).map(jobId => jobs.get(jobId)!)}
                />
            }

            {children}
        </>

    )


})